var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamarkets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2000px",
    height: "2007px",
    viewBox: "0 0 2000 2007",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Metamarkets") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Metamarkets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2000,486.725664 L2000,2007.24055 L479.485117,2007.24055 L479.485117,486.725664 L2000,486.725664 Z M1739.91193,746.813736 L739.573189,746.813736 L739.573189,1747.15247 L1739.91193,1747.15247 L1739.91193,746.813736 Z",
    id: "Orange-Rectangle",
    fill: "#F95F39",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.51488,0 L1520.51488,1520.51488 L0,1520.51488 L0,0 L1520.51488,0 Z M1260.42681,260.088072 L260.088072,260.088072 L260.088072,1260.42681 L1260.42681,1260.42681 L1260.42681,260.088072 Z",
    id: "Blue-Rectangle",
    fill: "#52B6E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "dark-square",
    fill: "#14213E",
    x: 1260.65969,
    y: 486.725664,
    width: 259.855189,
    height: 259.855189
  }), /*#__PURE__*/React.createElement("rect", {
    id: "dark-square",
    fill: "#14213E",
    x: 479.485117,
    y: 1260.65969,
    width: 259.855189,
    height: 259.855189
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamarkets);
export default __webpack_public_path__ + "static/media/metamarkets.f25ed70573758274e88ee7ab76143013.svg";
export { ForwardRef as ReactComponent };